<template>
  <div>
    <md-card class="md-card-profile">
      <div class="md-card-avatar" data-background-color="red">
        <md-icon style="color: white">privacy_tip</md-icon>
      </div>
      <md-card-content>
        <h6 class="category text-gray">Login Failure</h6>
        <h4 class="card-title">{{ totalFailureAttempts }} Attempts</h4>
        <md-button v-if="totalFailureAttempts > 0" class="md-primary" @click="openDialog">
          <md-icon>keyboard_arrow_right</md-icon>
          View All
        </md-button>
      </md-card-content>
    </md-card>
    <login-attempts :show="failureAttemptsDialogVisible" :attempts="currentFailureAttempts" @close="closeDialog">
      <template #failureAttempts="{ item }">
        <md-table-cell md-label="Attempt time">{{ item.attemptTime | formatLoginAttemptTime }}</md-table-cell>
        <md-table-cell v-if="item.username" md-label="Username">
          <div class="cells-with-icon">
            {{ item.username }}
            <sub>
              <md-button class="md-icon-button md-dense" @click="deleteByUsernameDialogVisible = true">
                <md-icon>delete_sweep</md-icon>
              </md-button>
            </sub>
          </div>
        </md-table-cell>
        <md-table-cell md-label="IP address">
          <div class="cells-with-icon">
            {{ item.ipAddress }}
            <sub>
              <md-button class="md-icon-button md-dense" @click="deleteByIpAddressDialogVisible = true">
                <md-icon>delete_sweep</md-icon>
              </md-button>
            </sub>
          </div>
        </md-table-cell>
        <md-table-cell md-label="User agent" class="user-agent">
          {{ item.userAgent }}
          <md-tooltip md-direction="top" class="user-agent-tooltip">{{ item.userAgent }}</md-tooltip>
        </md-table-cell>
        <md-table-cell v-if="item.userAgent" md-label="Path info">
          {{ item.pathInfo }}
          <md-tooltip md-direction="top" class="user-agent-tooltip">{{ item.pathInfo }}</md-tooltip>
        </md-table-cell>
        <md-table-cell v-if="item.failuresSinceStart" md-label="Failures Since Start">{{
          item.failuresSinceStart
        }}</md-table-cell>
        <md-table-cell v-if="item.failuresSinceStart" md-label="Action">
          <sub>
            <md-button class="md-icon-button" @click="deleteRowDialogVisible = true">
              <md-tooltip md-direction="top">Delete</md-tooltip>
              <md-icon>delete</md-icon>
            </md-button>
          </sub>
        </md-table-cell>
        <are-you-sure
          :show="deleteRowDialogVisible"
          message="This action will delete the selected failed login attempt. Are you sure?"
          @approve="
            deleteRowDialogVisible = false;
            deleteFailureAttemptRowAction(item.id);
          "
          @close="deleteRowDialogVisible = false"
        ></are-you-sure>
        <are-you-sure
          :show="deleteByUsernameDialogVisible"
          message="This action deletes all failed login attempts with this username. Are you sure?"
          @approve="
            deleteByUsernameDialogVisible = false;
            deleteByUsernameAction(item.username);
          "
          @close="deleteByUsernameDialogVisible = false"
        ></are-you-sure>
        <are-you-sure
          :show="deleteByIpAddressDialogVisible"
          message="This action deletes all failed login attempts with this IP address. Are you sure?"
          @approve="
            deleteByIpAddressDialogVisible = false;
            deleteByIpAddressAction(item.ipAddress);
          "
          @close="deleteByIpAddressDialogVisible = false"
        ></are-you-sure>
      </template>
    </login-attempts>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import LoginAttempts from "@/components/LoginAttempts.vue";
import NotificationStore from "@/components/NotificationPlugin/NotificationStore";
import apiManager from "@/api-manager";
import AreYouSure from "@/components/AreYouSure.vue";
import snakeCaseObjectKeysToCamelCase from "@/utils/snakeCaseObjectKeysToCamelCase";
export default {
  components: { LoginAttempts, AreYouSure },
  name: "FailureAttempts",
  props: ["show"],
  setup() {
    const failureAttemptsDialogVisible = ref(false);
    onMounted(async () => {
      await fetchFailureAttempts();
    });

    const closeDialog = () => {
      failureAttemptsDialogVisible.value = false;
    };

    const openDialog = async () => {
      await fetchFailureAttempts();
      failureAttemptsDialogVisible.value = true;
    };

    const notifySuccess = (msg) => {
      NotificationStore.notify({
        message: msg,
        icon: "info",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
    };

    const deleteRowDialogVisible = ref(false);
    const deleteFailureAttemptRowAction = async (id) => {
      closeDialog();
      const response = await apiManager.deleteFailureAttempts({
        params: { access_attempt_pk: id },
      });
      if (response.status === 200) {
        notifySuccess(response.parsedData.message);
        await fetchFailureAttempts();
      }
      if (totalFailureAttempts.value > 0) {
        openDialog();
      }
    };

    const deleteByUsernameDialogVisible = ref(false);
    const deleteByUsernameAction = async (username) => {
      closeDialog();
      const response = await apiManager.deleteFailureAttempts({
        params: { username: username },
      });
      if (response.status === 200) {
        notifySuccess(response.parsedData.message);
        await fetchFailureAttempts();
      }
      if (totalFailureAttempts.value > 0) {
        openDialog();
      }
    };

    const deleteByIpAddressDialogVisible = ref(false);
    const deleteByIpAddressAction = async (ipAddress) => {
      closeDialog();
      const response = await apiManager.deleteFailureAttempts({
        params: { ip_address: ipAddress },
      });
      if (response.status === 200) {
        notifySuccess(response.parsedData.message);
        await fetchFailureAttempts();
      }
      if (totalFailureAttempts.value > 0) {
        openDialog();
      }
    };

    const currentFailureAttempts = ref([]);
    const totalFailureAttempts = ref(0);
    const fetchFailureAttempts = async () => {
      const response = await apiManager.getFailureAttempts();
      if (response.status === 200) {
        currentFailureAttempts.value = snakeCaseObjectKeysToCamelCase(response.parsedData.admin_attempts);
        totalFailureAttempts.value = response.parsedData.total_items;
      }
    };

    return {
      failureAttemptsDialogVisible,

      closeDialog,
      openDialog,

      deleteRowDialogVisible,
      deleteFailureAttemptRowAction,

      deleteByUsernameDialogVisible,
      deleteByUsernameAction,

      deleteByIpAddressDialogVisible,
      deleteByIpAddressAction,

      currentFailureAttempts,
      fetchFailureAttempts,

      totalFailureAttempts,
    };
  },
};
</script>

<style scoped>
.cells-with-icon {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
